<template>
  <div class="b-solution">
    <div v-if="item.new" class="e-new"><NewLottie /></div>

    <div class="b-solution__picture">
      <BannerFootage :item="item" />
    </div>
    <div class="b-solution__main">
      <div v-if="item.logo" class="b-solution__logo mb-20">
        <LazyImage :image="item.logo" />
      </div>
      <div class="b-solution__title mb-15 h2">{{ item.title }}</div>
      <article class="b-article mb-40" v-html="item.summary"></article>
      <div v-if="item.link" class="b-solution__footer">
        <Anchor :item="item.link" class="btn btn-primary btn-full-width" />
      </div>
    </div>
  </div>
</template>

<script>
import Anchor from './common/Anchor.vue'
import LazyImage from './common/LazyImage.vue'
import NewLottie from './lotties/New.vue'
import BannerFootage from './BannerFootage.vue'

export default {
  components: { LazyImage, Anchor, NewLottie, BannerFootage },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
}
</script>
